module.exports = __webpack_public_path__ + "static/flags/LG-c7423efe8109ec47645c145d0cdb8785.gif";